export function createDataManagerColumnResizePreview({
  headerCell = null,
  pointerX = null,
  table = null,
} = {}) {
  if (!headerCell || typeof document === "undefined" || !document.body) {
    return {
      remove() {},
      update() {},
    };
  }

  const headerRect = headerCell.getBoundingClientRect();
  const resolvedPointerX = Number.isFinite(pointerX) ? pointerX : headerRect.right;
  const fixedViewportOffsetX = document.documentElement.getBoundingClientRect().left;
  const top = Math.max(0, headerRect.top);
  const scrollBottom = table?.parentElement?.getBoundingClientRect?.().bottom ?? window.innerHeight;
  const bottom = Math.max(top, Math.min(window.innerHeight, scrollBottom));
  const preview = document.createElement("div");
  preview.setAttribute("data-data-manager-column-resize-preview", "true");
  preview.setAttribute("aria-hidden", "true");
  Object.assign(preview.style, {
    background: "var(--color-accent)",
    borderRadius: "4px",
    boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.72)",
    height: `${Math.max(1, Math.round(bottom - top))}px`,
    left: `${Math.round(resolvedPointerX - fixedViewportOffsetX - 1)}px`,
    pointerEvents: "none",
    position: "fixed",
    top: `${Math.round(top)}px`,
    transform: "translate3d(0px, 0, 0)",
    willChange: "transform",
    width: "2px",
    zIndex: "2147483646",
  });
  document.body.appendChild(preview);

  return {
    remove() {
      preview.remove();
    },
    update(deltaX) {
      const resolvedDeltaX = Math.round(Number(deltaX) || 0);
      preview.style.transform = `translate3d(${resolvedDeltaX}px, 0, 0)`;
    },
  };
}
